// import node module libraries
import React, { Fragment, useEffect, useState } from 'react';
import { Card, Col, Container, Nav, Navbar, Row } from 'react-bootstrap';
import { Link, useLocation, useParams } from 'react-router-dom';
import ProfileBackground from 'assets/images/background/profile-bg.jpg';

// import routes file
// import utility file
import LivreService from '../../services/LivreService';
import { Avatar } from '../../../elements/bootstrap/Avatar';

const LivreProfileLayout = (props) => {
	const location = useLocation();

	const [livre, setLivre] = useState(null);
	const { id } = useParams();

	useEffect(() => {
		Promise.all([LivreService.getLivre(id)]).then(([livreData]) => {
			setLivre(livreData.data);
		});
	}, [id]);

	const getInitials = (livre) => {
		const auteur =
			livre && livre.auteur ? livre.auteur.charAt(0).toUpperCase() : '';
		const titre =
			livre && livre.titre ? livre.titre.charAt(0).toUpperCase() : '';
		return `${titre} ${auteur}`;
	};

	const initials = livre && getInitials(livre);

	return (
		<Fragment>
			<section className="pt-5 pb-5">
				<Container>
					{livre && (
						<>
							{/* User info */}
							<Row className="align-items-center">
								<Col xl={12} lg={12} md={12} sm={12}>
									<div
										className="pt-16 rounded-top-md"
										style={{
											background: `url(${ProfileBackground})`,
											backgroundRepeat: 'no-repeat',
											backgroundSize: 'cover'
										}}
									>
										{' '}
									</div>
									<Card className="px-4 pt-2 pb-4 rounded-0 rounded-bottom shadow-sm">
										<div className="d-flex align-items-end justify-content-between  ">
											<div className="d-flex align-items-center">
												<div className="me-2 position-relative d-flex justify-content-end align-items-end mt-n5">
													<Avatar
														type="initial"
														size="xl"
														name={initials || ''}
														className="rounded-circle"
														alt={initials || ''}
													/>
												</div>
												<div className="lh-1">
													<h3 className="mb-0 text-uppercase">
														{livre.titre || ''}
													</h3>
													<p className="mb-0 d-block text-uppercase">
														{livre.auteur || ''}
													</p>
												</div>
											</div>
											<div>
												<Link
													to="/services/bibliotheque/catalogue"
													className={`btn btn-outline-dark btn-sm d-none d-md-block`}
												>
													Retour à la liste des livres
												</Link>
											</div>
										</div>
									</Card>
								</Col>
							</Row>

							{/* Content */}
							<Row className="mt-0 mt-md-4">
								<Col lg={3} md={4} sm={12}>
									<Navbar
										expand="lg"
										className="navbar navbar-expand-md navbar-light shadow-sm mb-4 mb-lg-0 sidenav"
									>
										<Link
											className="d-xl-none d-lg-none d-md-none text-inherit fw-bold fs-5 float-start py-1"
											to="#"
										>
											Menu
										</Link>
										<Navbar.Toggle
											aria-controls="basic-navbar-nav"
											className="p-0 focus-none border-0"
											label="Responsive Menu"
										>
											<span
												className="navbar-toggler d-md-none icon-shape icon-sm rounded bg-primary p-0 text-white float-end"
												data-bs-toggle="collapse"
												data-bs-target="#sidenav"
												aria-controls="sidenav"
												aria-expanded="false"
												aria-label="Toggle navigation"
											>
												<span className="fa-solid fa-menu"></span>
											</span>
										</Navbar.Toggle>

										<Navbar.Collapse id="basic-navbar-nav">
											<Nav
												className="me-auto flex-column"
												as="ul"
												activeKey="0"
											>
												<Nav.Item className="navbar-header mt-4" as="li">
													Profile du livre
												</Nav.Item>
												<Nav.Item as="li">
													{
														<Link
															className={`nav-link ${
																location.pathname ===
																`/services/bibliotheque/catalogue/${livre.id}`
																	? 'active'
																	: ''
															}`}
															to={`/services/bibliotheque/catalogue/${livre.id}`}
														>
															<i className={`fa-solid fa-gear nav-icon`}></i>
															Mettre à jour le profil
														</Link>
													}
												</Nav.Item>
												<Nav.Item as="li">
													{
														<Link
															className={`nav-link ${
																location.pathname ===
																`/services/bibliotheque/catalogue/${livre.id}/delete`
																	? 'active'
																	: ''
															}`}
															to={`/services/bibliotheque/catalogue/${livre.id}/delete`}
														>
															<i className={`fa-solid fa-trash nav-icon`}></i>
															Supprimer le livre
														</Link>
													}
												</Nav.Item>
											</Nav>
										</Navbar.Collapse>
									</Navbar>
								</Col>

								<Col lg={9} md={8} sm={12}>
									{props.children}
								</Col>
							</Row>
						</>
					)}
				</Container>
			</section>
		</Fragment>
	);
};
export default LivreProfileLayout;
